import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import { FiArrowLeft, FiTrendingUp } from 'react-icons/fi';

const MyDegreePathPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />

      <main className="max-w-7xl mx-auto px-4 py-6">
        <div className="mb-6">
          <button
            onClick={() => navigate('/home')}
            className="flex items-center text-uc-navy hover:text-uc-gold transition-colors mb-4"
          >
            <FiArrowLeft size={20} className="mr-2" />
            Back to Home
          </button>
          <h1 className="text-3xl font-bold text-uc-navy font-header">My Degree Path</h1>
          <p className="text-gray-600 mt-2">Track your progress toward degree completion</p>
        </div>

        <div className="bg-white rounded-lg shadow p-8">
          <div className="text-center py-12">
            <FiTrendingUp size={64} className="mx-auto text-uc-gold mb-4" />
            <h2 className="text-2xl font-bold text-uc-navy mb-2">My Degree Path</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Track your progress toward degree completion
            </p>
            <div className="mt-8 p-6 bg-blue-50 rounded-lg max-w-2xl mx-auto">
              <p className="text-sm text-blue-900">
                This page is currently under development. Please check back later for updates.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MyDegreePathPage;
